import { jsx, jsxs } from 'react/jsx-runtime';
import 'react';
import '@dynamic-labs/sdk-api';
import '../../../../shared/logger.js';
import '../../../../config/LSSuffix.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import '../../../../context/ViewContext/ViewContext.js';
import '@dynamic-labs/utils';
import '../../../../utils/constants/colors.js';
import 'ethers';
import { useOnClickOutside } from '../../../../shared/utils/hooks/useOnClickOutside/index.js';
import '../../../../shared/consts/index.js';
import { useInternalDynamicContext } from '../../../../context/DynamicContext/useInternalDynamicContext.js';
import '@dynamic-labs/multi-wallet';
import { ShadowDOM } from '../../../../components/ShadowDOM/ShadowDOM.js';
import '../../../../context/ThemeContext/ThemeContext.js';
import 'react-dom';
import 'react-focus-lock';
import '../../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import { OpacityTransition } from '../../../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../../../config/ApiEndpoint.js';
import '@dynamic-labs/rpc-providers';
import '../../../../context/ErrorContext/ErrorContext.js';
import '../../../../context/AccessDeniedContext/AccessDeniedContext.js';
import '../../../../components/IconButton/IconButton.js';
import '@dynamic-labs/wallet-book';
import '../../../../components/Alert/Alert.js';
import '../../../../context/MockContext/MockContext.js';
import '../../../../context/CaptchaContext/CaptchaContext.js';
import '../../../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import '../../../../components/Popper/Popper/Popper.js';
import '../../../../components/Popper/PopperContext/PopperContext.js';
import 'formik';
import 'yup';
import '../../../../components/MenuList/Dropdown/Dropdown.js';
import { useFundingContext } from '../../../../context/FundingContext/FundingContext.js';

const Modal = ({ onrampUrl }) => {
    const { fundingRef, setShowFunding } = useFundingContext();
    const close = () => {
        setShowFunding(false);
    };
    useOnClickOutside(fundingRef, close);
    return (jsx("div", Object.assign({ className: 'fund-wallet__modal', "data-testid": 'fund-wallet-modal' }, { children: jsx("div", Object.assign({ className: 'fund-wallet__modal-content', ref: fundingRef }, { children: jsx("iframe", { id: 'onramp-iframe', src: onrampUrl, allow: 'camera *;geolocation *', title: 'Crypto Onramp' }) })) })));
};
const FundWalletView = () => {
    const { primaryWallet } = useInternalDynamicContext();
    const { showFunding, fundingUrl, fundingEnabled } = useFundingContext();
    if (!fundingEnabled ||
        !showFunding ||
        !fundingUrl ||
        !(primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.address)) {
        return null;
    }
    return (jsx(ShadowDOM, { children: jsxs(OpacityTransition, Object.assign({ isShown: showFunding }, { children: [jsx("div", { className: 'fund-wallet__backdrop', "aria-hidden": 'true' }), jsx("div", Object.assign({ className: 'fund-wallet__modal-container' }, { children: jsx(Modal, { onrampUrl: fundingUrl }) }))] })) }));
};

export { FundWalletView, Modal };
